<template>
    <div>
        <div class="tj_bgs">
            <div class="h_bt">
                <h2 class="h_bh">热门推荐</h2>
                <p class="h_fli"></p>
            </div>
        </div>
        <div class="gdls">
            <dl class="gl" v-for="(item,index) in list" :key="index"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                <dt>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                        <img :src="item.piclink" width="270" height="270" class="sbm" alt="">
                    </router-link>
                </dt>
                <!-- <dd class="simg">
                    <img src="https://s.cccgx.com/t/26x26/images/qu/10631/gallery/20210624034435_93941.jpg" width="26" height="26" class="ss_m">
                </dd> -->
                <dd>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="gna pt10">
                        {{item.title}}
                    </router-link>
                    <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="pt_g mt5">
                        <em class="p_tag">{{item.sub_title}}</em>
                    </router-link>
                </dd>
                <dd class="gp_d">
                    <i class="rmb left">¥</i>
                    <b class="xj left">{{item.price}}</b>
                    <em class="cs_o">已售{{item.sale}}件</em>
                </dd>
                <dd class="pt5">
                    <em class="i_hot">热销</em>
                    <!-- <em class="i_video">视频</em> -->
                    <i class="i_by">包邮</i>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            list:[]
        }
    },
    mounted(){
        this.getHotProduct();
    },
    methods:{
        getHotProduct(){
            this.$api.getShop.getHotProduct({}).then(res=>{
                if(res.code == 200){
                    this.list = res.result.hot;
                }
            })
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/car.css');
</style>


// WEBPACK FOOTER //
// src/components/common/hot-product.vue